import React from 'react';
import { Container, Content } from 'rsuite';
import Warning from '../../components/Warning';

import TelasHistorico from './TelasHistorico';

const DownloadIndisponivel = () => (
  <Container className="main-container download-page">
    <Content className="content">
      <div role="alert">
        <Warning
          title="Arquivo indisponível"
          description="Este link antigo não aponta mais para um arquivo disponível. Gere o arquivo de novo ou procure por ele no histórico da tela de origem."
        />
        <TelasHistorico />
      </div>
    </Content>
  </Container>
);

export default DownloadIndisponivel;
